"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversionsList = void 0;
const date_fns_1 = require("date-fns");
const helpers_1 = require("../../helpers");
const conversionsList = (dateRange, filters, disablePreaggregation = false) => ({
    mutexKey: `conversionsList:dateRange:${dateRange[0]}:${dateRange[1]}:filters${JSON.stringify(filters)}`,
    notPreaggregatedMeasures: ['Conversions.notPreaggregatedMeasure'],
    queries: [
        {
            measures: [
                'Conversions.count',
                ...(disablePreaggregation || new Date(dateRange[0]) < (0, date_fns_1.subDays)(new Date(), 92)
                    ? ['Conversions.notPreaggregatedMeasure']
                    : []),
            ],
            dimensions: ['Conversions.internalId'],
            filters: [
                ...(filters ? (0, helpers_1.filterFilters)(filters, 'Conversions.') : []),
                {
                    member: 'Attribution.date',
                    operator: 'inDateRange',
                    values: [dateRange[0], dateRange[1]],
                },
            ],
            limit: 10000,
        },
    ],
    resultProcessor: (rows) => rows[0]
        .tablePivot()
        .filter(obj => Object.values(obj)[0] && Object.values(obj)[1])
        .sort((a, b) => Number(Object.values(b)[1]) - Number(Object.values(a)[1]))
        .map(obj => Object.values(obj)[0].toString()),
});
exports.conversionsList = conversionsList;
//# sourceMappingURL=conversionsList.js.map